import React from 'react'
import PriceOptionComponent from './price-option.component'
import { routes } from '../../../../constants/routes.constants'
import { connect } from 'react-redux'
import { history } from '../../../../helpers/history'
import { purchaseOption } from '../../../../constants/ticket-sale.constants'
import { Creators as TicketSaleCreators } from '../../../../ducks/ticket-sale/ticket-sale'
import PromotionCouponService from '../../../../services/promotion-coupon.service'

function PriceOptionContainer({
	user,
	price,
	client,
	onSelect,
	busCompany,
	canUpgrade,
	setBusCompany,
	setIsModalOpen,
	showUpgradeModal,
	setSelectedServiceCharge,
	setInsufficientPointsModalOpen,
	setIsOnlyMoneyOnPriceOption,
	pricesLength,
}) {
	const hasValue = price.value > 0
	const hasPoints = price.points > 0
	const hasPlusSign = hasValue && hasPoints

	const getUberPromotionCoupon = async () => {
		const data = await PromotionCouponService.getUberPromotionCoupon()
		return data
	}

	const onPriceSelected = (price) => {
		setIsOnlyMoneyOnPriceOption(price.points === 0)
		const mustBeAuthenticated =
			user === null && (price.points > 0 || price.forSubscribers)
		if (mustBeAuthenticated) {
			history.push(routes.ENTRAR, { redirectUrl: routes.COMPRA_DE_PASSAGEM })
			return
		}

		const onlyForSubscribers =
			price.forSubscribers && user !== null && user.plan === null

		if (onlyForSubscribers) {
			setIsModalOpen(true)
			return
		}

		const notEnoughPoints =
			client && client.balancePoints < price.pointsToShow

		if (notEnoughPoints) {
			setInsufficientPointsModalOpen(true)
			return
		}

		const onlyPoints = price.points > 0 && price.value == 0
		const onlyValue = price.value > 0 && price.points == 0

		setBusCompany(busCompany)

		if (onlyPoints)
			setSelectedServiceCharge(purchaseOption.points, busCompany)
		else if (onlyValue)
			setSelectedServiceCharge(purchaseOption.value, busCompany)
		else setSelectedServiceCharge(purchaseOption.pointsValue, busCompany)

		// if (canUpgrade) {
		if (false) {
			const dataPromotionCoupon = getUberPromotionCoupon()
			dataPromotionCoupon
				.then((response) => {
					showUpgradeModal(
						onSelect,
						price,
						response.data.userMessage,
						busCompany
					)
				})
				.catch((erro) => {
					showUpgradeModal(onSelect, price, '', busCompany)
				})
		} else onSelect(price)
	}

	return (
		<PriceOptionComponent
			price={price}
			hasValue={hasValue}
			hasPoints={hasPoints}
			hasPlusSign={hasPlusSign}
			onPriceSelected={onPriceSelected}
			pricesLength={pricesLength}
			isPublicBody={user && user.hasPublicBody}
			isRequester={user && user.isRequester}
		/>
	)
}

const mapStateToProps = ({ user, client }) => ({ user, client })

const mapDispatchToProps = {
	setBusCompany: TicketSaleCreators.busCompany,
	setSelectedServiceCharge: TicketSaleCreators.setSelectedServiceCharge,
	setIsOnlyMoneyOnPriceOption: TicketSaleCreators.onlyMoneyOnPriceOption,
}

const PriceOption = connect(
	mapStateToProps,
	mapDispatchToProps
)(PriceOptionContainer)

export default PriceOption
